import { Box, Typography } from "@mui/material";
import React from "react";
import LoginMarquee from "./LoginMarquee";

function LoginBanner() {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "500px",
        color: "white",
      }}
    >
      <Typography fontSize={"3rem"} fontWeight={800} color="white">
        Hi... 👋
      </Typography>
      <Typography fontSize={"3rem"} fontWeight={800} color="white">
        Welcome to Authentis
      </Typography>
      {/* <Typography
        fontSize={"3rem"}
        fontWeight={800}
        color="white"
        sx={{
          mt: "-20px",
        }}
      >
        transporter! 
      </Typography> */}
      <Typography
        fontSize={"1.2rem"}
        fontWeight={300}
        color="white"
        sx={{
          mt: "20px",
        }}
      >
        Your trusted partner for managing vehicles and tracking locations with
        ease! Get FASTag-powered updates to keep your business running smoothly
        and efficiently.
      </Typography>
      <Box
        sx={{
          width: "100%",
          height: "60px",
          mt: {
            xs: "180px",
            md: "250px",
          },
        }}
      >
        <LoginMarquee />
      </Box>
      <Typography
        fontSize={"1.2rem"}
        fontWeight={500}
        color="white"
        sx={{
          mt: "20px",
        }}
      >
        Made with ❤️ in India.
      </Typography>
    </Box>
  );
}

export default LoginBanner;
